if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends BasicModal {
      constructor() {
        super();
      }
    }
  );
}

/**
 * Pickup availability (mağazadan teslim alma) bilgilerindeki metinleri değiştiren script
 * 
 * İşlevler:
 * 1. Sayfa yüklendiğinde: pickup-availability-info__pickup-time class'ındaki metni değiştirir
 * 2. "ShowPickupAvailabilityDrawer" butonuna tıklandığında: 
 *    100ms bekledikten sonra pickup-availability-list__item-info class'ındaki metni değiştirir
 * 
 * Gecikme sebebi: Drawer (yan panel) açılırken içerik dinamik olarak yüklendiği için 
 * elementlerin DOM'a eklenmesini beklemek gerekiyor.
 */


// Sayfa yüklendiğinde çalışacak fonksiyon
function changePickupTextOnLoad() {
    const elements = document.querySelectorAll('.text-subtext.text-sm-extra.m-0.pickup-availability-info__pickup-time');
    elements.forEach(element => {
        element.innerHTML = 'Same-day pickup before 4:30 PM <br> Store hours Mon-Fri | 9 AM-5 PM';
    });
}

// Butona tıklandığında çalışacak fonksiyon
function changePickupTextOnClick() {
    const elements = document.querySelectorAll('.pickup-availability-list__item-info.flex.gap-1');
    elements.forEach(element => {
        element.innerHTML = 'Same-day pickup before 4:30 PM <br> Store hours Mon-Fri | 9 AM-5 PM';
    });
}

// Sayfa tamamen yüklendiğinde çalıştır
window.addEventListener('load', function() {
    changePickupTextOnLoad();
    
    // Butona click event ekle
    const button = document.getElementById('ShowPickupAvailabilityDrawer');
    if (button) {
        button.addEventListener('click', function() {
            // Drawer'ın açılması için 100ms gecikme
            setTimeout(changePickupTextOnClick, 100);
        });
    }
});